var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"bounds"},[_c('img',{staticClass:"image",attrs:{"src":_vm.image,"alt":"Your GIF"}})]),_c('div',{staticClass:"download"},[_c(_setup.AppButton,{attrs:{"color":"gradient","size":"large","href":_vm.image,"download":""}},[_vm._v("Download GIF")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }